export interface IGradient {
	gray05: (degree: number) => string;
	white: (degree: number) => string;
}

const gradient: IGradient = {
	gray05: (degree) =>
		`linear-gradient(${degree}deg, rgba(248, 249, 250, 0) 0%, #F8F9FA 100%)`,
	white: (degree) =>
		`linear-gradient(${degree}deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)`,
};

export default gradient;
